import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, ConfirmationModal, Modal } from '@percent/lemonade'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation } from '@percent/admin-dashboard/common/hooks'
import { SewaOnboardingListItemEnriched } from '@percent/admin-dashboard/api/actions/sewaOnboarding/sewaOnboarding.types'

export type OffboardModalProps = {
  org: SewaOnboardingListItemEnriched
  onClose: () => void
  refresh: () => void
}

export function OffboardModal({ org, onClose, refresh }: OffboardModalProps) {
  const { t } = useTranslation()
  const { sewaOnboardingService } = useServices()

  const [{ isLoading, success, error }, { apiFunc, setError }] = useMutation(sewaOnboardingService.offboardOrganisation)

  const handleClose = () => {
    if (success) refresh()
    onClose()
  }

  const handleSubmit = async () => {
    await apiFunc({ organisationId: org.organisationId })
  }

  return (
    <Modal open onClose={handleClose}>
      {success && (
        <AcknowledgeModal
          result="positive"
          title={t('sewaOnboarding.modal.offboard.successTitle')}
          buttonText={t('button.close')}
          handleClose={handleClose}
        >
          {t('sewaOnboarding.modal.offboard.successDescription')}
        </AcknowledgeModal>
      )}

      {!success && error && (
        <AcknowledgeModal
          result="negative"
          title={t('sewaOnboarding.modal.offboard.errorTitle')}
          buttonText={t('button.close')}
          handleClose={() => setError('')}
        >
          {t('sewaOnboarding.modal.offboard.errorDescription')}
        </AcknowledgeModal>
      )}

      {!success && !error && (
        <ConfirmationModal
          title={t('sewaOnboarding.modal.offboard.title')}
          loading={isLoading}
          primaryButtonText={t('sewaOnboarding.modal.offboard.submit')}
          secondaryButtonText={t('button.cancel')}
          handleSubmit={handleSubmit}
          handleClose={onClose}
        >
          {t('sewaOnboarding.modal.offboard.description', { orgName: org.organisationName })}
        </ConfirmationModal>
      )}
    </Modal>
  )
}
